// const trkey: any = {
// 	en: {
// 		trkey: {
// 		}
// 	},
// 	de: {
// 		trkey: {
// 		}
// 	}
// }

import { createI18n } from 'vue-i18n'

const modul: any = {
	en: {
		modul: {
			Takeover: `Takeover`,
			loadAllLogs: `Load all Logs?`,
			customgraph: `Custom Graph`,
			moduledata: `Module Data`,
			sensorSettings: `Sensor Settings`,
			graphSettings: `Graph Settings`,
			logData: `Log Data`,
			historyData: `History`,
			noLogDataAvailable: `No Log-Data available`,
			deleteAllLogs: `Delete all selected logs`,
			deselectAll: `Deselect all`,
			selectAll: `Select all`,
			editDbDataInfo: `Careful, you are about to change original Log Data.`,
			Sensor: `Sensor`,
			Value: `Value`,
			Offset: `Offset`,
			Factor: `Factor`,
			withOffset: `with Offset`,
			comment: `Comment`,
			comments: `Comments`,
			Timestamp: `Timestamp`,
			Timearea: `Timearea`,
			from: `from`,
			to: `to`,
			timekeyExpected: `Timekey (expected Interval)`,
			offsetValue: `offset value`,
			FwO: `F.w.O.`,
			cstUnit: `cstUnit`,
			unit: `unit`,
			hub: `Hub`,
			module: `Module`,
			sensorKey: `Sensor Key`,
			min: `min`,
			calcFormula: `( SENSOR VALUE + OFFSET ) * FACTOR`,
			Graph: `Graph`,
			Calc: `Calc`,
			Show: `Show`,
			Color: `Color`,
			newComment: `New comment`,
			allowedTimesteps: `allowed Timesteps`,
			minAverageTimestep: `min. average Timestep`,
			chartId: `Chart Id`,
			info: {
				chartId: {
					title: `Info Chart Id`,
					description:
						`ChartId is used to assign sensors to graphs. Use identical ChartIds for sensors that should be shown together (e.g., same units). ChartIds are sorted alphabetically. Sensors without ChartId are grouped at the end and automatically split into graphs (max 32 per graph).`,
				},
				minMax: {
					title: `Info Min/Max`,
					description: `Sensor values below Min or above Max are ignored to filter outliers.`,
				},
			},
		},
	},
	de: {
		modul: {
			Takeover: `Übernehmen`,
			loadAllLogs: `Alle Logs laden?`,
			customgraph: `Graph`,
			moduledata: `Modul Einstellungen`,
			sensorSettings: `Sensor Einstellungen`,
			graphSettings: `Graph Einstellungen`,
			logData: `Log Daten`,
			historyData: `Änderungen`,
			noLogDataAvailable: `keine Log-Daten verfügbar`,
			deleteAllLogs: `Alle ausgewählten Logs löschen`,
			deselectAll: `Alle abwählen`,
			selectAll: `Alle auswählen`,
			editDbDataInfo: `Achtung, Änderung von original Daten.`,
			Sensor: `Sensor`,
			Value: `Wert`,
			Offset: `Offset`,
			Factor: `Faktor`,
			withOffset: `mit Offset`,
			comment: `Kommentar`,
			comments: `Kommentare`,
			Timestamp: `Zeitpunkt`,
			Timearea: `Zeitraum`,
			from: `von`,
			to: `bis`,
			timekeyExpected: `Timekey (erwartetes Intervall)`,
			offsetValue: `Offset Wert`,
			FwO: `F.m.O.`,
			cstUnit: `eig.Einheit`,
			unit: `Einheit`,
			hub: `Hub`,
			module: `Modul`,
			sensorKey: `Sensorkey`,
			min: `Min`,
			calcFormula: `( SENSORWERT + OFFSET ) * FAKTOR`,
			Graph: `Graph`,
			Calc: `Berechnen`,
			Show: `Anzeigen`,
			Color: `Farbe`,
			newComment: `Neuer Kommentar`,
			allowedTimesteps: `erlaubte Zeitintervalle`,
			minAverageTimestep: `Minimales Zeitintervall`,
			chartId: `Chart Id`,
			info: {
				chartId: {
					title: `Info Chart Id`,
					description:
						`ChartId wird für die Zuordnung der Sensoren zu den Graphen verwendet. Wenn mehrere Sensoren gemeinsam dargestellt werden sollen (z. B. gleiche Einheit), sollten die ChartIds identisch sein. ChartIds werden alphabetisch sortiert. Sensoren ohne ChartId werden zuletzt gruppiert (max. 32 Sensoren pro Graph) und automatisch aufgeteilt.`,
				},
				minMax: {
					title: `Info Min/Max`,
					description: `Sensorwerte unterhalb von Min oder oberhalb von Max werden ignoriert, um Ausreißer zu filtern.`,
				},
			},
		},
	},
}

const files: any = {
	en: {
		files: {
			preview: `Preview`,
			files: `Files`,
			popupsBlocked: `Popups are Blocked.`,
			popupsBlockedDownload: `Popups are Blocked. Download here: `,
			folders: `Folders`,
			noFilesAvailable: `No Files Available`,
			useDragNDrop: `Use Drag & Drop to upload files.`,
			linkPrepared: `Link prepared`,
			noLinksPrepared: `No links prepared`,
		},
	},
	de: {
		files: {
			preview: `Vorschau`,
			files: `Dateien`,
			popupsBlocked: `Popups sind gesperrt.`,
			popupsBlockedDownload: `Popups sind gesperrt. Download hier: `,
			folders: `Ordner`,
			noFilesAvailable: `Keine Dateien vorhanden`,
			useDragNDrop: `Drag & Drop zum Hochladen von Dateien verwenden.`,
			linkPrepared: `Link vorbereitet`,
			noLinksPrepared: `Keine Links vorbereitet`,
		},
	},
}

const panelModul: any = {
	en: {
		panelModul: {
			allProjects: `All Projects`,
			allLocations: `All Locations`,
			allHubs: `All Hubs`,
			allComapps: `All Comapps`,
			General: `General`,
			addCustomGraph: `add custom graph`,
			showModules: `show Modules`,
			noModCgAssigned: `no Modules/Cg. asssigned`,
		},
	},
	de: {
		panelModul: {
			allProjects: `Alle Projekte`,
			allLocations: `Alle Orte`,
			allHubs: `Alle Hubs`,
			allComapps: `Alle Comapps`,
			General: `Allgemein`,
			addCustomGraph: `Graph hinzufügen`,
			showModules: `Zeige Module`,
			noModCgAssigned: `keine Module/Graphen`,
		},
	},
}

const modulList: any = {
	en: {
		modulList: {
			noHubsAssigned: `No Hubs assigned!`,
			lastCall: `last Call`,
		},
	},
	de: {
		modulList: {
			noHubsAssigned: `Keine Hubs zugeordnet`,
			lastCall: `letzter Aufruf`,
		},
	},
}

const comappsList: any = {
	en: {
		comappsList: {
			noComappsAssigned: `No Comapps assigned!`,
			name: `Name`,
			location: `Location`,
			lastOnline: `last Online`,
			lastFileSent: `last files sent`,
			status: `Status`,
			version: `Version`,
		},
	},
	de: {
		comappsList: {
			noComappsAssigned: `Keine Comapps zugeordnet`,
			name: `Name`,
			location: `Ort`,
			lastOnline: `zuletzt online`,
			lastFileSent: `zuletzt gesendet`,
			status: ` Status`,
			version: ` Version`,
		},
	},
}

const graph: any = {
	en: {
		graph: {
			viewStyle: `Style`,
			viewOptions: `Options`,
			movingAverage: `Mv. Average`,
			averageTimeStep: `Time interval Δt`,

			curve: `Curve`,
			mainLines: `Lines`,
			chartdots: `Dots`,
			offsets: `offsets`,
			minMaxArea: `minMaxArea`,
			alertLines: `Alert Lines`,
			infoBox: `Info Box`,
			showMissingDataGaps: `show MissingDataGaps`,
			daysNights: `days/nights`,

			commentLines: `Comments`,
			// normal: `normal`,
			reference: `reference`,
			viewForPrint: `print`,
			autoscale: `autoscale`,
			includeAlertInMinMax: `show Min/Max Alert Lines`,
			historyLines: `History Dots`,
			novalues: `No values available for this graph!`,
		},
	},
	de: {
		graph: {
			viewStyle: `Ansicht`,
			viewOptions: `Optionen`,
			movingAverage: `Mittelwert (Zeitfenster)`,
			averageTimeStep: `Zeitinterval Δt`,

			curve: `Glättung`,
			mainLines: `Linien`,
			chartdots: `Punkte`,
			offsets: `Offsets`,
			referenceView: `Referenz Ansicht`,
			minMaxArea: `Min/Max-Fläche`,
			alertLines: `Alarm-Linien`,
			infoBox: `Info Box`,
			showMissingDataGaps: `fehlende Logs`,
			daysNights: `Tage/Nächte`,
			commentLines: `Kommentare`,

			// normal: `Initiale Ansicht`,
			reference: `Referenzansicht`,
			viewForPrint: `Druckansicht`,
			autoscale: `Auto.Skalierung`,
			includeAlertInMinMax: `ink. Warn/Alarm Linien`,
			historyLines: `Änderungen `,
			novalues: `Keine Daten für diesen Graphen verfügbar!`,
		},
	},
}

const chart: any = {
	en: {
		chart: {
			csvDownload: `CSV/TSV download`,
			from: `From`,
			to: `To`,
			format: {
				json: `JSON`,
				csv: `CSV`,
				tsv: `TSV (Excel)`,
			},
			quality: `Data quality`,
			default: `Default`,
			withOffsetFactor: `with offset/factor`,
			original: `Original`,
			valuesAsTheyAre: `Values as they are`,
			csvDownloadError: `Error downloading: {error}`,
		},
	},
	de: {
		chart: {
			csvDownload: `CSV/TSV Download`,
			from: `Von`,
			to: `Bis`,
			format: {
				json: `JSON`,
				csv: `CSV`,
				tsv: `TSV (Excel)`,
			},
			quality: `Datenqualität`,
			default: `Standard`,
			withOffsetFactor: `mit Offset/Faktor`,
			original: `Original`,
			valuesAsTheyAre: `Werte wie sie sind`,
			csvDownloadError: `Fehler beim Download: {error}`,
		},
	},
}

const server: any = {
	en: {
		server: {
			emailAlreadyRegistered: 'Email is already registered.',
			emailPasswordMismatch: `Email and password don't match.`,
			needverification: `Please verify your email.`,
			signInSuccess: `You signed in successfully.`,
			registerSuccess: `You registered successfully. Please check your emails and click on the verification link we just sent you.`,
			registerFailedAcceptTerms: `Please accept the privacy policy and the terms and conditions.`,

			verificationEmailSent: `A verification reset-email was sent to you! Click on the link in the email and then login.`,

			userNoEmail: `No email given.`,
			userCheckPassword: `No valid password (min 6 chars).`,
			userExistsAlready: `User email exists already!`,
			userAdded: `User added successfully.`,
			userNoFoundToDelete: `No user found for given ID!`,
			userDeleted: `User deleted successfully.`,
			placeholder: `placeholder`,
		},
	},
	de: {
		server: {
			emailAlreadyRegistered: 'Email ist bereits registeriert.',
			emailPasswordMismatch: `Bitte Email und Passwort kontrollieren.`,
			needverification: `Email ist nicht verifiziert. Bitte Link im Email klicken.`,
			signInSuccess: `Anmeldung erfolgreich.`,
			registerSuccess: `Registrierung erfolgreich. Bitte in der soeben gesendeten Email den Link klicken zum Verifizieren.`,
			registerFailedAcceptTerms: `Bitte akzepiteren Sie die Datenschutrichtlinien und die AGB.`,
			verificationEmailSent: `Ein Verifizierungsemail wurde versendet! Zum Verifizieren bitte im Email den Link klicken.`,

			userNoEmail: `Keine Email gegeben!`,
			userCheckPassword: `Password nicht valide (min. 6 Zeichen)`,
			userExistsAlready: `Benutzer existiert bereits.`,
			userAdded: `Benutzer erfolgreich hinzugefügt`,
			userNoFoundToDelete: `Kein Benutzer zum Löschen gefunden (Keine Id gegeben!)`,
			userDeleted: `Benutzer erfolgreich gelöscht.`,
			placeholder: `placeholder`,
		},
	},
}

const menu: any = {
	en: {
		menu: {
			Home: `Home`,
			projects: `Projects`,
			settings: `Settings`,
			main: `Main`,
			admin: `Admin`,
			base: `General`,
			developer: `developer`,
			Locations: `Locations`,
			Projects: `Projects`,
			Modules: `Modules`,
			Comapps: `Comapps`,
			IPCalls: `IPCalls`,
			ChangeLogs: `ChangeLogs`,
			User: `Account`,
			Users: `Users`,
			Admin: `Admin`,
			GraphAlerts: `Graph Alerts`,
			Alerts: `Alerts`,
			Yocto: `YoctoWS`,
			Inventory: `Inventory`,

			updateAvailable: `Update available`,
			AlertMatrix: `Alert Matrix`,
			AlertMatrixByUser: `Alert Matrix User`,
			AlertMatrixForGraphs: `Alert Matrix Graphs`,
		},
	},
	de: {
		menu: {
			Home: `Karte`,
			projects: `Projekte`,
			settings: `Einstellungen`,
			main: `Main`,
			admin: `Admin`,
			base: `Allgemein`,
			developer: `Entwickler`,
			Locations: `Orte`,
			Projects: `Projekte`,
			Modules: `Module`,
			Comapps: `Comapps`,
			IPCalls: `IPCalls`,
			ChangeLogs: `Änderungs-Logs`,
			User: `Konto`,
			Users: `Benutzer`,
			Admin: `Admin`,
			GraphAlerts: `Graph Alarm`,
			Alerts: `Alarm`,
			Yocto: `YoctoWS`,
			Inventory: `Inventar`,

			updateAvailable: `Update available`,
			AlertMatrix: `Alarm Matrix`,
			AlertMatrixByUser: `Alarm Matrix Benutzer`,
			AlertMatrixForGraphs: `Alarm Matrix Graphen`,
		},
	},
}

const signin: any = {
	en: {
		signin: {
			signin: 'Sign In',
			email: 'Email',
			password: 'Password',
			dataPolicy: 'Data Policy',
			terms: 'Terms',
			login: 'Login',
			verification: 'Verification',
			verifyEmailInfo: 'You need to verify your email.',
			clickLinkInEmail: 'Please click on the Link in the email.',
			resendVerificationEmail: "If you haven't got one yet, please try to resend it here:",
			resendVerificationEmailBtn: `Resend a verification email`,
			backtologin: 'Back to login',
			register: 'Register',
			registerHere: 'Register Here',
			forgotPassword: 'Forgot your password!',
			forgotPasswordQ: 'Forgot your password?',
			sendEmailResetPassword: 'Send email to reset password',
			youareloggedinas: 'You are logged in as',
			logout: 'Log out',
		},
	},
	de: {
		signin: {
			signin: 'Anmelden',
			email: 'Email',
			password: 'Passwort',
			dataPolicy: 'Datenschutz',
			terms: 'AGB',
			login: 'Einloggen',
			verification: 'Verifizierung',
			verifyEmailInfo: 'Email ist noch nicht verifiziert.',
			clickLinkInEmail: 'Bitte Link im Email klicken.',
			resendVerificationEmail: 'Falls kein Email empfangen wurde, hier Email neu versenden lassen:',
			resendVerificationEmailBtn: `Verifizierungsemail neu versenden.`,
			backtologin: 'Zurück zur Anmeldung',
			register: 'Registrieren',
			registerHere: 'Zur Registrierung',
			forgotPassword: 'Password vergessen!',
			forgotPasswordQ: 'Password vergessen?',
			sendEmailResetPassword: 'Email senden zum Zurücksetzen des Passworts',
			youareloggedinas: 'Sie sind angemeldet als ',
			logout: 'Ausloggen',
		},
	},
}

const profile: any = {
	en: {
		profile: {
			account: `Account`,
			title: `User Profile`,
			subtitle: `Review your details, access and session.`,
			sectionAccount: `Account`,
			sectionAccess: `Project Access`,
			name: `Name`,
			email: `Email`,
			role: `Role`,
			defaultRole: `user`,
			userId: `User ID`,
			projectAllowed: `allowed`,
			projectAllAccess: `Full access to all projects.`,
			projectNone: `No project restrictions assigned yet.`,
			fallbackName: `User`,
			noUser: `No user session loaded.`,
		},
	},
	de: {
		profile: {
			account: `Konto`,
			title: `Benutzerprofil`,
			subtitle: `Prüfen Sie Ihre Daten, Zugriffe und Sitzung.`,
			sectionAccount: `Konto`,
			sectionAccess: `Projektzugriff`,
			name: `Name`,
			email: `Email`,
			role: `Rolle`,
			defaultRole: `Benutzer`,
			userId: `Benutzer-ID`,
			projectAllowed: `erlaubt`,
			projectAllAccess: `Voller Zugriff auf alle Projekte.`,
			projectNone: `Keine Projektbeschränkungen vergeben.`,
			fallbackName: `Benutzer`,
			noUser: `Keine Benutzersitzung geladen.`,
		},
	},
}

const users: any = {
	en: {
		users: {
			users: 'Users',
			user: 'User',
			email: 'Email',
			telephone: 'Telephone',
			firstname: 'Firstname',
			lastname: 'Lastname',
			password: 'Password',
			role: 'Role',
			isOnEmailAlert: 'Alert on emails',
			id: 'ID',
			assignedProjects: 'Access projects',
			addNewUser: 'Add new user',
			addUser: 'Add user',
			deleteUser: 'Delete user',
		},
	},
	de: {
		users: {
			users: 'Benutzer',
			user: 'Benutzer',
			email: 'Email',
			telephone: 'Telefon',
			firstname: 'Vorname',
			lastname: 'Nachname',
			password: 'Passwort',
			role: 'Rolle',
			isOnEmailAlert: 'Alarm auf Emails',
			id: 'ID',
			assignedProjects: 'Zugriff auf Projekte',
			addNewUser: 'Benutzer hinzufügen',
			addUser: 'Benutzer hinzufügen',
			deleteUser: 'Benutzer löschen',
		},
	},
}

const inventory: any = {
	en: {
		inventory: {
			Inventory: 'Inventory',
			Meta: 'Meta',
			'Supplier/Manufactorer': 'Supplier/Manufactorer',
		},
	},
	de: {
		inventory: {
			Inventory: 'Inventory',
			Meta: 'Meta',
			'Supplier/Manufactorer': 'Lieferanten/Hersteller',
		},
	},
}

const general: any = {
	//! no need to use 'general.${string}'
	en: {
		sure: 'Sure?',
		delete: 'Delete',
		save: 'Save',
		replace: 'Replace',
		general: 'General',
		name: 'Name',
		shortName: 'Short Name',
		Yes: 'Yes',
		Confirm: 'Confirm',
		OK: 'OK',
		CANCEL: 'Cancel',
	},
	de: {
		sure: 'Sicher?',
		delete: 'Löschen',
		save: 'Speichern',
		replace: 'Ersetzen',
		general: 'Allgemein',
		name: 'Name',
		shortName: 'Kurzname',
		Yes: 'Ja',
		Confirm: 'Bestätigen',
		OK: 'OK',
		CANCEL: 'Abbrechen',
	},
}

export const translations = {
	en: {
		...menu.en,
		...signin.en,
		...profile.en,
		...server.en,
		...general.en,
		...modulList.en,
		...comappsList.en,
		...modul.en,
		...files.en,
		...panelModul.en,
		...users.en,
		...inventory.en,
		...graph.en,
		...chart.en,
	},
	de: {
		...menu.de,
		...signin.de,
		...profile.de,
		...server.de,
		...general.de,
		...modulList.de,
		...comappsList.de,
		...modul.de,
		...files.de,
		...panelModul.de,
		...users.de,
		...inventory.de,
		...graph.de,
		...chart.de,
	},
}

export const i18n = createI18n({
	legacy: false,
	globalInjection: true,
	messages: translations,
	// locale: 'de', // set locale
	locale: 'de', // set locale
	fallbackLocale: 'en', // set fallback locale
})
